'use client';
import Button from '~/components/commonUi/Button/Button';
import Checkbox from '~/components/commonUi/Checkbox/Checkbox';
import { XMarkIcon } from '@heroicons/react/16/solid';
import { observer } from 'mobx-react';
import { Region } from '~/definitions/region';
import { getStore } from '~/mobx/AppStore';

interface Props {
    isDisabled: boolean;
    items: Region[];
    checkedIds: string[];
    onSubmit: () => void;
    onCheckboxChange: (id: string) => void;
}

const Regions = observer((props: Props) => {
    const { items, onSubmit, onCheckboxChange, checkedIds, isDisabled = false } = props;

    const handleFormSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        onSubmit();
    };

    const handleCheckboxChange = (itemId: string) => {
        onCheckboxChange(itemId);
    };

    if (isDisabled) {
        return (
            <ul className="mb-[15px]">
                {items.map((item) => {
                    const itemId = item?.id || '';
                    return (
                        <li className="border-b border-gray-300 py-2" key={itemId}>
                            {item?.name}
                        </li>
                    );
                })}
            </ul>
        );
    }

    return (
        <form action="" method="post" onSubmit={handleFormSubmit}>
            <ul className="mb-[15px]">
                {items.map((item) => {
                    const itemId = item?.id || '';
                    return (
                        <li className="border-b border-gray-300 py-2" key={itemId}>
                            <Checkbox
                                id={`delete-region-${itemId}`}
                                label={item?.name}
                                checked={checkedIds.includes(itemId)}
                                onChange={() => handleCheckboxChange(itemId)}
                            />
                        </li>
                    );
                })}
            </ul>
            <Button
                type="submit"
                btnText="Slett markerte"
                testId="btn-delete-regions"
                size="small"
                icon={<XMarkIcon className="size-5 text-red-500" />}
            />
        </form>
    );
});

const RegionsWithStore = () => {
    const { regionStore, generalSettingsStore } = getStore();

    return (
        <Regions
            isDisabled={generalSettingsStore.isSettingsDisabled}
            items={regionStore.regions}
            checkedIds={regionStore.checkedRegionIds}
            onSubmit={regionStore.submitDeleteRegions}
            onCheckboxChange={regionStore.toggleCheckedRegionId}
        />
    );
};

export default observer(RegionsWithStore);
